import { ADD_REQUEST_STATUS } from "./types/types";

export default (value, key) => ({
    type: ADD_REQUEST_STATUS,
    payload: {
        key,
        value
    }
});